<template>
  <div :style="{ marginTop: '20px', paddingBottom: '80px' }">

    <div v-if="!loading" style="text-align: left; color: #666" class="d-flex align-items-center justify-content-center">
      <form @submit.prevent="save_config">
        <table width="90%" style="font-size: 18px; font-weight: bold" cellpadding="10px">
          <tr data-field="vehicle_status_management_enabled">
            <td align="right" width="500">Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_show_tag_filters">
            <td align="right" width="500">Show Tag Filters</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_show_tag_filters" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_vehicle_tag_filter">
            <td align="right" width="500">Vehicle Tag Filter</td>
            <!-- NOT migrated to FilterSettingEditor: this field's backend (tbn_vehicle_status_manager.py
                 ~270-287) has its own bespoke include/exclude tag syntax (plain tag = include,
                 "-tag" = exclude, both usable together) with NO `*` wildcard sentinel at all. Our
                 "Allow all except..." mode would serialize as "*,-X", and this backend treats the
                 literal "*" token as a real tag name to intersect on — since no vehicle has a tag
                 named "*", that would silently hide the entire fleet. Left as a plain text input. -->
            <td width="800"><b-form-input v-model="model.vehicle_status_management_vehicle_tag_filter" type="text" :state="filterState('vehicle_status_management_vehicle_tag_filter')" @input="validateFilter('vehicle_status_management_vehicle_tag_filter', $event)"></b-form-input>
            <b-form-invalid-feedback :state="filterState('vehicle_status_management_vehicle_tag_filter')">{{ filterFeedback('vehicle_status_management_vehicle_tag_filter') }}</b-form-invalid-feedback></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_vehicle_base_filter">
            <td align="right" width="500">Vehicle Base Filter</td>
            <td width="800">
              <FilterSettingEditor
                v-model="model.vehicle_status_management_vehicle_base_filter"
                fieldKey="vehicle_status_management_vehicle_base_filter"
                variant="wildcard"
                :allow-raw-edit="isEffectiveAdmin"
                @validation="onFilterValidation"
              />
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_yard_vehicle_tag_filter">
            <td align="right" width="500">Yard Status Change Vehicle Tag Filter</td>
            <td width="800">
              <FilterSettingEditor
                v-model="model.vehicle_status_management_yard_vehicle_tag_filter"
                fieldKey="vehicle_status_management_yard_vehicle_tag_filter"
                variant="wildcard"
                :allow-raw-edit="isEffectiveAdmin"
                @validation="onFilterValidation"
              />
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_dirty_after_days_vehicle_tag_filter">
            <td align="right" width="500">Dirty After Days Vehicle Tag Filter</td>
            <td width="800">
              <FilterSettingEditor
                v-model="model.vehicle_status_management_dirty_after_days_vehicle_tag_filter"
                fieldKey="vehicle_status_management_dirty_after_days_vehicle_tag_filter"
                variant="wildcard"
                :allow-raw-edit="isEffectiveAdmin"
                @validation="onFilterValidation"
              />
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_dirty_after_days">
            <td align="right" width="500">Dirty After Days (instead of yard arrival)</td>
            <td width="800">
              <b-form-input v-model="model.vehicle_status_management_dirty_after_days" type="text" :state="numericState('vehicle_status_management_dirty_after_days')" @input="validateNumeric('vehicle_status_management_dirty_after_days', $event, 0, 365)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('vehicle_status_management_dirty_after_days')">{{ numericFeedback('vehicle_status_management_dirty_after_days') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_status_aliases">
            <td align="right" width="500">Status Aliases</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_status_aliases" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_yard_leave_miles">
            <td align="right" width="500">Yard Leave Miles</td>
            <td width="800">
              <b-form-input v-model="model.vehicle_status_management_yard_leave_miles" type="text" :state="numericState('vehicle_status_management_yard_leave_miles')" @input="validateNumeric('vehicle_status_management_yard_leave_miles', $event, 0, 100)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('vehicle_status_management_yard_leave_miles')">{{ numericFeedback('vehicle_status_management_yard_leave_miles') }}</b-form-invalid-feedback>
            </td>
            <td width="250">how far a vehicle must get from the yard to go OUT (kept wide so fuel/shop runs don't thrash)</td>
          </tr>
          <tr data-field="vehicle_status_management_yard_return_miles">
            <td align="right" width="500">Yard Return Miles</td>
            <td width="800">
              <b-form-input v-model="model.vehicle_status_management_yard_return_miles" type="text" :state="numericState('vehicle_status_management_yard_return_miles')" @input="validateNumeric('vehicle_status_management_yard_return_miles', $event, 0, 100)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('vehicle_status_management_yard_return_miles')">{{ numericFeedback('vehicle_status_management_yard_return_miles') }}</b-form-invalid-feedback>
            </td>
            <td width="250">how close a vehicle must get to the yard to go DIRTY (defaults to 0.4)</td>
          </tr>
          <tr data-field="vehicle_status_management_skip_vehicles">
            <td align="right" width="500">Skip Vehicles</td>
            <td width="800">
              <!-- Backend does an exact comma-split membership check (vehicle name not in
                   skip list) — plain exclusion list, no `*`/`-` wildcard support. -->
              <FilterSettingEditor
                v-model="model.vehicle_status_management_skip_vehicles"
                fieldKey="vehicle_status_management_skip_vehicles"
                variant="list"
                :allow-raw-edit="isEffectiveAdmin"
                @validation="onFilterValidation"
              />
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="user.tenant == 'anderson-759g468f' || user.tenant== 'tbn-demo' || user.tenant== 'initek-tbn'" data-field="vehicle_status_management_tote_config">
            <td align="right" width="500">Tote Options</td>
            <td width="800"><b-form-textarea rows="3" v-model="model.vehicle_status_management_tote_config" type="text"></b-form-textarea></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'CM'" data-field="vehicle_status_management_departs_in_offset_minutes">
            <td align="right" width="500">Depart In Offset Minutes</td>
            <td width="800">
              <b-form-input v-model="model.vehicle_status_management_departs_in_offset_minutes" type="text" :state="numericState('vehicle_status_management_departs_in_offset_minutes')" @input="validateNumeric('vehicle_status_management_departs_in_offset_minutes', $event, 0, 1440)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('vehicle_status_management_departs_in_offset_minutes')">{{ numericFeedback('vehicle_status_management_departs_in_offset_minutes') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'" data-field="vehicle_status_management_use_driver_start_time">
            <td align="right" width="500">Use Driver Start For Next Depart Time</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_use_driver_start_time" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_future_hours">
            <td align="right" width="500">Future Hours</td>
            <td width="800">
              <b-form-input v-model="model.vehicle_status_management_future_hours" type="text" :state="numericState('vehicle_status_management_future_hours')" @input="validateNumeric('vehicle_status_management_future_hours', $event, 0, 168)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('vehicle_status_management_future_hours')">{{ numericFeedback('vehicle_status_management_future_hours') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'CM'" data-field="vehicle_status_management_future_hours_driver">
            <td align="right" width="500">Future Hours (Driver View)</td>
            <td width="800">
              <b-form-input v-model="model.vehicle_status_management_future_hours_driver" type="text" :state="numericState('vehicle_status_management_future_hours_driver')" @input="validateNumeric('vehicle_status_management_future_hours_driver', $event, 0, 168)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('vehicle_status_management_future_hours_driver')">{{ numericFeedback('vehicle_status_management_future_hours_driver') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_future_bookings_count">
            <td align="right" width="500">Future Bookings Count</td>
            <td width="800">
              <b-form-input v-model="model.vehicle_status_management_future_bookings_count" type="text" :state="numericState('vehicle_status_management_future_bookings_count')" @input="validateNumeric('vehicle_status_management_future_bookings_count', $event, 0, 100)"></b-form-input>
              <b-form-invalid-feedback :state="numericState('vehicle_status_management_future_bookings_count')">{{ numericFeedback('vehicle_status_management_future_bookings_count') }}</b-form-invalid-feedback>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Portal Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_columns = !view_customize_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_standalone_columns = !view_customize_standalone_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Active Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_active_columns = !view_customize_active_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Cleaning Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_cleaning_columns = !view_customize_cleaning_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Maintenance Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_maintenance_columns = !view_customize_maintenance_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Standalone Driver Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_driver_columns = !view_customize_driver_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <!-- FI-2267: the /vsm-es board is linked from the cm boards only -->
          <tr v-if="tenant_type == 'CM'" data-field="vehicle_status_management_visible_es_fields">
            <td align="right" width="500">Spanish Wash Board Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_es_columns = !view_customize_es_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>

          <tr>
            <td align="right" width="500">Mobile Visible Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_mobile_columns = !view_customize_mobile_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_visible_update_fields">
            <td align="right" width="500">Extra Update Fields</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_visible_update_fields" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr>
            <td align="right" width="500">Portal Visible History Fields</td>
            <td width="800">
              <b-button variant="info" size="sm" @click="view_customize_history_columns = !view_customize_history_columns"><b>Customize Columns</b></b-button>
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_email_oos_recipient">
            <td align="right" width="500">Email OOS Recipient</td>
            <td width="800"><b-form-input v-model="model.vehicle_status_management_email_oos_recipient" type="text"></b-form-input></td>
            <td width="250">&nbsp;</td>
          </tr>

          <tr data-field="vehicle_status_management_auto_set_ready_enabled">
            <td align="right" width="500">Auto Set Ready Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_auto_set_ready_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_clear_notes_on_clean_enabled">
            <td align="right" width="500">Clear Notes on Clean Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_clear_notes_on_clean_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_maint_summary_enabled">
            <td align="right" width="500">Maintenance Summary Enabled</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_maint_summary_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'" data-field="vehicle_status_management_tbn_oos_events_filter">
            <td align="right" width="500">TBN OOS Events Filter</td>
            <td width="800">
              <FilterSettingEditor
                v-model="model.vehicle_status_management_tbn_oos_events_filter"
                fieldKey="vehicle_status_management_tbn_oos_events_filter"
                variant="wildcard"
                placeholder="ex: Lack of Drivers"
                :allow-raw-edit="isEffectiveAdmin"
                @validation="onFilterValidation"
              />
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr v-if="tenant_type == 'TBN'" data-field="vehicle_status_management_tbn_pm_events_filter">
            <td align="right" width="500">TBN PM Events Filter</td>
            <td width="800">
              <FilterSettingEditor
                v-model="model.vehicle_status_management_tbn_pm_events_filter"
                fieldKey="vehicle_status_management_tbn_pm_events_filter"
                variant="wildcard"
                placeholder="ex: Lack of Drivers"
                :allow-raw-edit="isEffectiveAdmin"
                @validation="onFilterValidation"
              />
            </td>
            <td width="250">&nbsp;</td>
          </tr>
          <tr data-field="vehicle_status_management_schedule_options">
            <td align="right" width="500">Schedule Options</td>
            <td width="800"><b-form-textarea rows="3" v-model="model.vehicle_status_management_schedule_options" type="text"></b-form-textarea></td>
            <td width="250">&nbsp;</td>
          </tr>

          <tr data-field="vehicle_status_management_row_colors_disabled">
            <td align="right" width="500">Disable Row Background Colors</td>
            <td width="800"><b-form-select v-model="model.vehicle_status_management_row_colors_disabled" :options="boolean_options" style="width:100px"></b-form-select></td>
            <td width="250">when disabled, the wash status shows as a left edge color and the maint status as a bottom edge color</td>
          </tr>

          <tr v-if="isEffectiveAdmin">
            <td align="right"><span style="color: var(--fi-rail-accent); font-weight: bold; font-size: 24px;" v-on:click="toggle_div(toggle,'isAdvVisible')">{{ toggle.isAdvVisible ? "▾" : "▸" }} Advanced</span></td>
            <td></td>
            <td></td>
          </tr>
          <template v-if="toggle.isAdvVisible">
            <tr data-field="vehicle_status_management_confirmation_enabled">
              <td align="right" width="500">Driver Confirmation Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_maint_enabled">
              <td align="right" width="500">Simple Maintenance Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_maint_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_dvir_enabled">
              <td align="right" width="500">DVIR Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_dvir_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_dvir_combined">
              <td align="right" width="500">DVIR Combined Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_dvir_combined" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'" data-field="vehicle_status_management_tbn_status_enabled">
              <td align="right" width="500">TBN Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_tbn_status_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_rta_enabled">
              <td align="right" width="500">RTA Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_rta_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_fleetio_enabled">
              <td align="right" width="500">Fleetio Maintenance Mode Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_fleetio_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_fleetio_to_tbn_enabled">
              <td align="right" width="500">Fleetio Sync To TBN Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_fleetio_to_tbn_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_fleetio_to_tbn_event_type">
              <td align="right" width="500">Fleetio Sync To TBN Event Type</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_fleetio_to_tbn_event_type" type="text" placeholder="Out of Service"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_fleetio_to_tbn_window_days">
              <td align="right" width="500">Fleetio Sync To TBN Window Days</td>
              <td width="800">
                <b-form-input v-model="model.vehicle_status_management_fleetio_to_tbn_window_days" type="text" placeholder="0 = current day only" :state="numericState('vehicle_status_management_fleetio_to_tbn_window_days')" @input="validateNumeric('vehicle_status_management_fleetio_to_tbn_window_days', $event, 0, 365)"></b-form-input>
                <b-form-invalid-feedback :state="numericState('vehicle_status_management_fleetio_to_tbn_window_days')">{{ numericFeedback('vehicle_status_management_fleetio_to_tbn_window_days') }}</b-form-invalid-feedback>
              </td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'" data-field="vehicle_status_management_vsm_oos_to_tbn_enabled">
              <td align="right" width="500">VSM OOS Sync To TBN Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_vsm_oos_to_tbn_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr v-if="tenant_type == 'TBN'" data-field="vehicle_status_management_vsm_oos_to_tbn_event_type">
              <td align="right" width="500">VSM OOS Sync To TBN Event Type</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_vsm_oos_to_tbn_event_type" type="text" placeholder="VSM OOS"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_maintainx_to_tbn_enabled">
              <td align="right" width="500">MaintainX Sync To TBN Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_maintainx_to_tbn_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_fleetio_pm_status">
              <td align="right" width="500">Fleetio Status To Mark for PM</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_fleetio_pm_status" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_fleetio_oos_status">
              <td align="right" width="500">Fleetio Status To Mark for OOS</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_fleetio_oos_status" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_unifi_enabled">
              <td align="right" width="500">Unifi Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_unifi_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_date_time_format">
              <td align="right" width="500">Date Time Format Override</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_date_time_format" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_stats_enabled">
              <td align="right" width="500">Extra Vehicle Stats Enabled (odo, fuel, def)</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_stats_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_washed_enabled">
              <td align="right" width="500">Separate Clean vs. Wash Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_washed_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_reset_clean_wash_on_dirty_enabled">
              <td align="right" width="500">Reset Clean / Wash On Dirty Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_reset_clean_wash_on_dirty_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_booking_leave_logic_enabled">
              <td align="right" width="500">Booking Leave OUT Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_booking_leave_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_booking_return_logic_enabled">
              <td align="right" width="500">Booking Return DIRTY Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_booking_return_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_yard_leave_logic_enabled">
              <td align="right" width="500">Yard Leave OUT Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_yard_leave_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_yard_return_logic_enabled">
              <td align="right" width="500">Yard Return DIRTY Status Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_yard_return_logic_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_sms_confirmation_enabled">
              <td align="right" width="500">SMS Confirmation Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_sms_confirmation_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_sms_invalid_msg_response_enabled">
              <td align="right" width="500">SMS Invalid Message Response Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_sms_invalid_msg_response_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_include_booking_only_vehicles_enabled">
              <td align="right" width="500">Include Booking Only Vehicles Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_include_booking_only_vehicles_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_yard_filter">
              <td align="right" width="500">Yard Filter</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_yard_filter" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_include_vehicle_info_only_enabled">
              <td align="right" width="500">Include Vehicle Info Only Enabled</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_include_vehicle_info_only_enabled" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_future_booking_on_separate_row">
              <td align="right" width="500">Future Bookings On Separate Row</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_future_booking_on_separate_row" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_show_eta_for_out_vehicles">
              <td align="right" width="500">Show ETA For OUT Vehicles</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_show_eta_for_out_vehicles" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_driver_switch_continuation">
              <td align="right" width="500">Driver Switch Continuation</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_driver_switch_continuation" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_show_recent_departures">
              <td align="right" width="500">Show Recently Departed Vehicles</td>
              <td width="800"><b-form-select v-model="model.vehicle_status_management_show_recent_departures" :options="boolean_options" style="width:100px"></b-form-select></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_font_size">
              <td align="right" width="500">Standalone Font Size Override</td>
              <td width="800">
                <b-form-input v-model="model.vehicle_status_management_font_size" type="text" :state="numericState('vehicle_status_management_font_size')" @input="validateNumeric('vehicle_status_management_font_size', $event, 8, 48)"></b-form-input>
                <b-form-invalid-feedback :state="numericState('vehicle_status_management_font_size')">{{ numericFeedback('vehicle_status_management_font_size') }}</b-form-invalid-feedback>
              </td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_standalone_window_height">
              <td align="right" width="500">Standalone Window Height Override</td>
              <td width="800">
                <b-form-input v-model="model.vehicle_status_management_standalone_window_height" type="text" :state="numericState('vehicle_status_management_standalone_window_height')" @input="validateNumeric('vehicle_status_management_standalone_window_height', $event, 100, 5000)"></b-form-input>
                <b-form-invalid-feedback :state="numericState('vehicle_status_management_standalone_window_height')">{{ numericFeedback('vehicle_status_management_standalone_window_height') }}</b-form-invalid-feedback>
              </td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_history_statuses">
              <td align="right" width="500">History Statuses</td>
              <td width="800"><b-form-input v-model="model.vehicle_status_management_history_statuses" type="text"></b-form-input></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_user_customizable_fields">
              <td align="right" width="500">User Customizable Fields</td>
              <td width="800"><b-form-textarea v-model="model.vehicle_status_management_user_customizable_fields" rows="3" placeholder="Comma-delimited list of field keys that users can customize in the 'more info' modal. Leave empty to allow all fields."/></td>
              <td width="250">&nbsp;</td>
            </tr>
            <tr data-field="vehicle_status_management_history_customizable_fields">
              <td align="right" width="500">History Customizable Fields</td>
              <td width="800"><b-form-textarea v-model="model.vehicle_status_management_history_customizable_fields" rows="3" placeholder="Comma-delimited list of history field keys that can be customized. Leave empty to allow all history fields."/></td>
              <td width="250">&nbsp;</td>
            </tr>

          </template>


        </table>


      </form>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

    <b-modal title="Customize Columns - Portal" size="xl" v-model="view_customize_columns" @show="syncCustomizeColumnsWithVisibleFields">
      <br/>
      <h4>Customize Portal Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'portal-' + customizeColumnsResetKey"
        v-model="customizeColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_fields', 'view_customize_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - Standalone" size="xl" v-model="view_customize_standalone_columns" @show="syncCustomizeStandaloneColumnsWithVisibleFields">
      <br/>
      <h4>Customize Standalone Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'standalone-' + customizeStandaloneColumnsResetKey"
        v-model="customizeStandaloneColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeStandaloneColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_standalone_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_standalone_fields', 'view_customize_standalone_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - Cleaning" size="xl" v-model="view_customize_cleaning_columns" @show="syncCustomizeCleaningColumnsWithVisibleFields">
      <br/>
      <h4>Customize Cleaning Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'cleaning-' + customizeCleaningColumnsResetKey"
        v-model="customizeCleaningColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeCleaningColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_cleaning_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_cleaning_fields', 'view_customize_cleaning_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - Active" size="xl" v-model="view_customize_active_columns" @show="syncCustomizeActiveColumnsWithVisibleFields">
      <br/>
      <h4>Customize Active Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'active-' + customizeActiveColumnsResetKey"
        v-model="customizeActiveColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeActiveColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_active_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_active_fields', 'view_customize_active_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - Maintenance" size="xl" v-model="view_customize_maintenance_columns" @show="syncCustomizeMaintenanceColumnsWithVisibleFields">
      <br/>
      <h4>Customize Maintenance Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'maintenance-' + customizeMaintenanceColumnsResetKey"
        v-model="customizeMaintenanceColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeMaintenanceColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_maintenance_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_maintenance_fields', 'view_customize_maintenance_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - Driver" size="xl" v-model="view_customize_driver_columns" @show="syncCustomizeDriverColumnsWithVisibleFields">
      <br/>
      <h4>Customize Driver Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'driver-' + customizeDriverColumnsResetKey"
        v-model="customizeDriverColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeDriverColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_driver_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_driver_fields', 'view_customize_driver_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - Spanish Wash Board" size="xl" v-model="view_customize_es_columns" @show="syncCustomizeEsColumnsWithVisibleFields">
      <br/>
      <h4>Customize Spanish Wash Board Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder. The board shows its column headers in Spanish.</p>
      <VsmFieldSelector
        :key="'es-' + customizeEsColumnsResetKey"
        v-model="customizeEsColumnsValue"
        field-type="main"
        :available-fields="availableEsFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeEsColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_es_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_es_fields', 'view_customize_es_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - Mobile" size="xl" v-model="view_customize_mobile_columns" @show="syncCustomizeMobileColumnsWithVisibleFields">
      <br/>
      <h4>Customize Mobile Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'mobile-' + customizeMobileColumnsResetKey"
        v-model="customizeMobileColumnsValue"
        field-type="main"
        :available-fields="availableFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeMobileColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_mobile_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_mobile_fields', 'view_customize_mobile_columns')">Save</b-button>
      </template>
    </b-modal>

    <b-modal title="Customize Columns - History" size="xl" v-model="view_customize_history_columns" @show="syncCustomizeHistoryColumnsWithVisibleFields">
      <br/>
      <h4>Customize History Visible Columns</h4>
      <p>Drag fields between columns to add/remove, or drag within selected fields to reorder.</p>
      <VsmFieldSelector
        :key="'history-' + customizeHistoryColumnsResetKey"
        v-model="customizeHistoryColumnsValue"
        field-type="history"
        :available-fields="availableHistoryFieldsForCustomize"
      />
      <br/>
      <b-button variant="secondary" @click="resetCustomizeHistoryColumns">Reset to Default</b-button>
      <template #modal-footer>
        <b-button variant="outline-secondary" @click="view_customize_history_columns = false">Cancel</b-button>
        <b-button variant="success" @click="saveColumnSetting('vehicle_status_management_visible_history_fields', 'view_customize_history_columns')">Save</b-button>
      </template>
    </b-modal>

  <div class="tc-sticky-save">
    <transition name="tc-save-slide">
    <div v-if="isDirty || saving" class="d-flex align-items-center justify-content-center">
      <span v-if="isDirty && !saving" class="tc-unsaved-label mr-3" @click="scrollToFirstDirtyField()" title="Click to scroll to unsaved field" style="cursor:pointer">&#9679; Unsaved changes</span>
      <b-btn size="lg" variant="success" @click="save_config" :disabled="saving">
          <b-spinner v-if="saving" small class="mr-1"></b-spinner>
          {{ saving ? 'Saving...' : 'Save' }}
        </b-btn>
      &nbsp;&nbsp;
      <b-btn size="lg" variant="secondary" @click="load_data(true)">Discard Changes</b-btn>
    </div>
    </transition>
  </div>
</div>

</template>
<script>
import {get_tenant_config_settings, update_tenant_config_settings} from '../networking/apis'
import {mapState} from "vuex";
import {
  VSM_FIELDS,
  VSM_HISTORY_FIELDS,
  VSM_ES_EXCLUDED_KEYS,
  defaultEsVisibleFieldsString,
  defaultHistoryVisibleFieldsString,
  defaultMainVisibleFieldsString,
  defaultMobileVisibleFieldsString,
  surfaceVisibleFieldsString,
} from '../utils/vsm_fields'
import { vsmBoardRouteName } from '../utils/vsm_access'
import numericValidationMixin from '../mixins/numeric_validation_mixin'
import VsmFieldSelector from './VsmFieldSelector.vue'
import filterValidationMixin from '../mixins/filter_validation_mixin'
import dirtyTrackingMixin from '../mixins/dirty_tracking_mixin'
import confirmDefaultsMixin from '../mixins/confirm_defaults_mixin'
import FilterSettingEditor from './FilterSettingEditor.vue'
import { ensureFilterKeys } from '../utils/filter_syntax'

export default {
  name: 'tenant_config',
  mixins: [filterValidationMixin, numericValidationMixin, dirtyTrackingMixin, confirmDefaultsMixin],
  components: {
    VsmFieldSelector,
    FilterSettingEditor,
  },
  data() {
    return {
      add_yard_model: {},
      manage_sos_yards: false,
      model: {},
      general_model: {},
      general_advanced_model: {},
      toggle: {},
      summary: {},
      view_customize_columns: false,
      customizeColumnsValue: '',
      customizeColumnsResetKey: 0,
      // Suppresses the customize*Value -> model watchers while a modal's
      // @show handler is hydrating its display value from a backend default
      // (tenant has no explicit setting saved), so merely opening a modal
      // doesn't flag the settings page as having unsaved changes.
      suppressCustomizeModelSync: false,
      view_customize_standalone_columns: false,
      customizeStandaloneColumnsValue: '',
      customizeStandaloneColumnsResetKey: 0,
      view_customize_cleaning_columns: false,
      customizeCleaningColumnsValue: '',
      customizeCleaningColumnsResetKey: 0,
      view_customize_active_columns: false,
      customizeActiveColumnsValue: '',
      customizeActiveColumnsResetKey: 0,
      view_customize_maintenance_columns: false,
      customizeMaintenanceColumnsValue: '',
      customizeMaintenanceColumnsResetKey: 0,
      view_customize_driver_columns: false,
      customizeDriverColumnsValue: '',
      customizeDriverColumnsResetKey: 0,
      view_customize_es_columns: false,
      customizeEsColumnsValue: '',
      customizeEsColumnsResetKey: 0,
      view_customize_mobile_columns: false,
      customizeMobileColumnsValue: '',
      customizeMobileColumnsResetKey: 0,
      view_customize_history_columns: false,
      customizeHistoryColumnsValue: '',
      customizeHistoryColumnsResetKey: 0,
      loading: true,
      isNotSysadmin: false,
      isSamaraType: false,
      yardsLength: 0,
      modal_help: {},
      objectKeyList: [],
      boolean_options: [
        { text: 'True', value: 'True' },
        { text: 'False', value: 'False' },
      ],
    }
  },
  async mounted() {
    this.load_data()
  },
  methods: {
    toggle_help(field) {
      if (!(field in this.modal_help))
        this.modal_help[field] = true
      else
        this.modal_help[field] = !this.modal_help[field]
      this.$forceUpdate();
    },
    async load_data(silent = false) {
      if (!silent) this.loading = true
      this.objectKeyList = []
      let loaded = false
      try {
        const {value: { data = [] } } = await get_tenant_config_settings(this.user.tenant)
        this.summary = data.summary
        this.model = data.results
        ensureFilterKeys(this.model, [
          'vehicle_status_management_vehicle_base_filter',
          'vehicle_status_management_yard_vehicle_tag_filter',
          'vehicle_status_management_dirty_after_days_vehicle_tag_filter',
          'vehicle_status_management_skip_vehicles',
          'vehicle_status_management_tbn_oos_events_filter',
          'vehicle_status_management_tbn_pm_events_filter',
          // not a filter, but needs the same Vue.set treatment so the input stays
          // reactive on tenants that have never had the setting saved
          'vehicle_status_management_fleetio_to_tbn_event_type',
          'vehicle_status_management_vsm_oos_to_tbn_event_type',
          'vehicle_status_management_fleetio_to_tbn_window_days',
          'vehicle_status_management_yard_return_miles',
          // FI-2267: new setting, absent from every tenant record until saved
          'vehicle_status_management_visible_es_fields',
        ])

        // Auto-fill user_customizable_fields with all VSM fields if empty
        const userCustomizableKey = 'vehicle_status_management_user_customizable_fields'
        const visibleFieldsKey = 'vehicle_status_management_visible_fields'
        
        const visibleFields = this.model[visibleFieldsKey] || ''
        const userCustomizableFields = this.model[userCustomizableKey] || ''
        
        // If user_customizable_fields is empty, fill it with all possible VSM field keys
        if (!userCustomizableFields || userCustomizableFields.trim() === '') {
          const allFieldKeys = this.tenantVsmFields.map(f => f.key).join(',')
          this.model[userCustomizableKey] = allFieldKeys
        } else {
          // Ensure user_customizable_fields contains all current VSM fields (handles new fields added over time)
          const customizableKeys = userCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
          const allVsmKeys = this.tenantVsmFields.map(f => f.key)
          const missingKeys = allVsmKeys.filter(k => !customizableKeys.includes(k))
          if (missingKeys.length > 0) {
            this.model[userCustomizableKey] = [...customizableKeys, ...missingKeys].join(',')
          }
        }

        // Auto-fill history_customizable_fields with all history fields if empty
        const historyCustomizableKey = 'vehicle_status_management_history_customizable_fields'
        const visibleHistoryFieldsKey = 'vehicle_status_management_visible_history_fields'
        
        const visibleHistoryFields = this.model[visibleHistoryFieldsKey] || ''
        const historyCustomizableFields = this.model[historyCustomizableKey] || ''
        
        // If history_customizable_fields is empty, fill it with all possible history field keys
        if (!historyCustomizableFields || historyCustomizableFields.trim() === '') {
          const allHistoryFieldKeys = VSM_HISTORY_FIELDS.map(f => f.key).join(',')
          this.model[historyCustomizableKey] = allHistoryFieldKeys
        } else if (visibleHistoryFields && visibleHistoryFields.trim() !== '') {
          // Ensure history_customizable_fields contains all fields from visible_history_fields
          const visibleHistoryKeys = visibleHistoryFields.split(',').map(k => k.trim()).filter(k => k)
          const customizableHistoryKeys = historyCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
          
          // Find fields in visible_history_fields that are not in history_customizable_fields
          const missingHistoryKeys = visibleHistoryKeys.filter(k => !customizableHistoryKeys.includes(k))
          
          // If there are missing fields, add them to history_customizable_fields
          if (missingHistoryKeys.length > 0) {
            const combinedHistoryKeys = [...customizableHistoryKeys, ...missingHistoryKeys]
            this.model[historyCustomizableKey] = combinedHistoryKeys.join(',')
          }
        }

        try {
          const entries = Object.entries(this.model);
          for (let [key,value] of entries) {
            if (this.isArrayType(value) || this.isPlainObject(value,key)) {
              let setting = JSON.stringify(value)
              //console.log('found plain object or array: key:'+key+ ' value: '+ setting);
              this.model[key] = setting
              this.objectKeyList.push(key)
            }
          }
        } catch(e) {
          console.log('error looping through keys',e)
        }
        loaded = true
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
      if (loaded) this._resetDirtyTracking()
    },
    async saveColumnSetting(modelKey, modalVisibilityKey) {
      try {
        this.$emit('showAlert', 'Saving column settings...', 'info', 5000)
        const config = { [modelKey]: this.model[modelKey] }
        await update_tenant_config_settings(this.user.tenant, config)
        // Partial-save helper: must patch the snapshot for the key(s) it sent,
        // per the contract on _dirtyFields(), otherwise this key reads dirty
        // forever and gets re-sent on the next full save_config().
        if (this.modelSnapshot !== null) {
          const snapshot = JSON.parse(this.modelSnapshot)
          snapshot[modelKey] = this.model[modelKey]
          this.modelSnapshot = JSON.stringify(snapshot)
        }
        this[modalVisibilityKey] = false
        this.$emit('showAlert', 'Column settings saved', 'success', 5000)
      } catch(e) {
        this.$emit('showAlert', 'Error saving column settings, try again or contact support', 'danger', 5000)
      }
    },
    async save_config() {
      try {
        this.saving = true
        this.flushNumericValidation()
        this.flushFilterValidation()
        if (this.hasNumericErrors()) {
          this.$emit('showAlert', 'Fix the highlighted field before saving', 'danger', 6000)
          this.scrollToFirstNumericError()
          return
        }
        if (this.hasFilterErrors()) {
          this.$emit('showAlert', 'Fix the highlighted filter field before saving', 'danger', 6000)
          this.scrollToFirstFilterError()
          return
        }
        // Compute dirty keys before parsing (model still holds JSON strings matching snapshot).
        const dirtyKeys = new Set(Object.keys(this._dirtyFields()))
        if (dirtyKeys.size === 0) {
          this.$emit('showAlert', 'No changes to save', 'info', 3000)
          return
        }
        this.$emit('showAlert', 'Saving Changes', 'info',5000)
        const fullPayload = Object.assign({}, this.model)
        for (const objkey of this.objectKeyList) {
          if (typeof fullPayload[objkey] === 'string') {
            try {
              if (fullPayload[objkey].trim() !== '') {
                fullPayload[objkey] = JSON.parse(fullPayload[objkey])
              }
            } catch (e) {
              this.$emit('showAlert', 'Invalid JSON in field: ' + objkey + ' — ' + e.message, 'danger', 8000)
              this.load_data()
              return
            }
          }
        }
        const payload = {}
        for (const key of dirtyKeys) {
          if (key in fullPayload) payload[key] = fullPayload[key]
        }

        await update_tenant_config_settings(this.user.tenant, payload)
        this._resetDirtyTracking()
        await this.load_data(true)
        this.$emit('showAlert', 'Configuration Saved', 'success',5000)
      } catch(e) {
        this.$emit('showAlert', this._saveErrorMessage(e), 'danger', 5000)
      }
      finally {
        this.saving = false
      }
    },
    set_tenant_id(id) {
      this.user.tenant = id
      this.load_data()
    },
    update_toggle_div(item,field,setting) {
      if (!item[field] && setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      } else if (item[field] && !setting) {
        item[field] = !item[field];
        this.$forceUpdate();
      }
    },
    toggle_div(item,field) {
      item[field] = !item[field];
      this.$forceUpdate();
    },
    isPlainObject(value,key) {
      //console.log('isPlainObject, value:' + value + ', type of value:' + (typeof value))
      let objtype = (typeof value)
      if (objtype == "object") {
        if (value != null && !Array.isArray(value)) {
          return true
        }
        return false
      }
    },
    isArrayType(value) {
      return Array.isArray(value)
    },
    // `label` names the board so the confirmation can say which set of columns
    // is about to be replaced. Worth asking about: the reset writes straight
    // into `model`, and the modal's Cancel only closes the dialog -- it does not
    // put the previous selection back.
    applyCustomizeReset(valueKey, resetKey, updateFn, defaultValue, label) {
      return this.confirmDefaults(
        `Reset the ${label} columns to the default selection? Your current choice of columns for this view will be replaced.`,
        () => {
          this[valueKey] = defaultValue
          updateFn.call(this)
          this[resetKey]++
        },
        'Reset to Default'
      )
    },
    // FI-2156: a modal opens on the columns the tenant's board is showing
    // right now -- their saved list for the surface, whatever the board falls
    // back to when they have not saved one, and only then the columns the
    // board renders with no config at all. It used to open on the curated
    // "Reset to Default" set, so on an unconfigured tenant dragging a single
    // field in saved nine columns over a board that had been rendering forty.
    seedCustomizeFields(surface) {
      const available = surface === 'history'
        ? this.availableHistoryFieldsForCustomize
        : surface === 'es'
          ? this.availableEsFieldsForCustomize
          : this.availableFieldsForCustomize
      return surfaceVisibleFieldsString(surface, this.model, this.vsmBoardRoute, available)
    },
    syncCustomizeColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeColumnsValue', this.seedCustomizeFields('portal'))
    },
    updateVisibleFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_fields = this.customizeColumnsValue
    },
    resetCustomizeColumns() {
      this.applyCustomizeReset(
        'customizeColumnsValue',
        'customizeColumnsResetKey',
        this.updateVisibleFieldsFromCustomize,
        defaultMainVisibleFieldsString(this.availableFieldsForCustomize),
        'Portal'
      )
    },
    syncCustomizeStandaloneColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeStandaloneColumnsValue', this.seedCustomizeFields('standalone'))
    },
    updateStandaloneFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_standalone_fields = this.customizeStandaloneColumnsValue
    },
    resetCustomizeStandaloneColumns() {
      this.applyCustomizeReset(
        'customizeStandaloneColumnsValue',
        'customizeStandaloneColumnsResetKey',
        this.updateStandaloneFieldsFromCustomize,
        defaultMainVisibleFieldsString(this.availableFieldsForCustomize),
        'Standalone'
      )
    },
    syncCustomizeCleaningColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeCleaningColumnsValue', this.seedCustomizeFields('cleaning'))
    },
    updateCleaningFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_cleaning_fields = this.customizeCleaningColumnsValue
    },
    resetCustomizeCleaningColumns() {
      this.applyCustomizeReset(
        'customizeCleaningColumnsValue',
        'customizeCleaningColumnsResetKey',
        this.updateCleaningFieldsFromCustomize,
        defaultMainVisibleFieldsString(this.availableFieldsForCustomize),
        'Cleaning'
      )
    },
    syncCustomizeActiveColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeActiveColumnsValue', this.seedCustomizeFields('active'))
    },
    updateActiveFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_active_fields = this.customizeActiveColumnsValue
    },
    resetCustomizeActiveColumns() {
      this.applyCustomizeReset(
        'customizeActiveColumnsValue',
        'customizeActiveColumnsResetKey',
        this.updateActiveFieldsFromCustomize,
        defaultMainVisibleFieldsString(this.availableFieldsForCustomize),
        'Active'
      )
    },
    syncCustomizeMaintenanceColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeMaintenanceColumnsValue', this.seedCustomizeFields('maintenance'))
    },
    updateMaintenanceFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_maintenance_fields = this.customizeMaintenanceColumnsValue
    },
    resetCustomizeMaintenanceColumns() {
      this.applyCustomizeReset(
        'customizeMaintenanceColumnsValue',
        'customizeMaintenanceColumnsResetKey',
        this.updateMaintenanceFieldsFromCustomize,
        defaultMainVisibleFieldsString(this.availableFieldsForCustomize),
        'Maintenance'
      )
    },
    syncCustomizeDriverColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeDriverColumnsValue', this.seedCustomizeFields('driver'))
    },
    updateDriverFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_driver_fields = this.customizeDriverColumnsValue
    },
    resetCustomizeDriverColumns() {
      this.applyCustomizeReset(
        'customizeDriverColumnsValue',
        'customizeDriverColumnsResetKey',
        this.updateDriverFieldsFromCustomize,
        defaultMainVisibleFieldsString(this.availableFieldsForCustomize),
        'Driver'
      )
    },
    syncCustomizeEsColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeEsColumnsValue', this.seedCustomizeFields('es'))
    },
    updateEsFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_es_fields = this.customizeEsColumnsValue
    },
    resetCustomizeEsColumns() {
      this.applyCustomizeReset(
        'customizeEsColumnsValue',
        'customizeEsColumnsResetKey',
        this.updateEsFieldsFromCustomize,
        defaultEsVisibleFieldsString(this.availableEsFieldsForCustomize),
        'Spanish Wash Board'
      )
    },
    syncCustomizeMobileColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeMobileColumnsValue', this.seedCustomizeFields('mobile'))
    },
    updateMobileFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_mobile_fields = this.customizeMobileColumnsValue
    },
    resetCustomizeMobileColumns() {
      this.applyCustomizeReset(
        'customizeMobileColumnsValue',
        'customizeMobileColumnsResetKey',
        this.updateMobileFieldsFromCustomize,
        defaultMobileVisibleFieldsString(this.availableFieldsForCustomize),
        'Mobile'
      )
    },
    syncCustomizeHistoryColumnsWithVisibleFields() {
      this.hydrateCustomizeValue('customizeHistoryColumnsValue', this.seedCustomizeFields('history'))
    },
    // Sets a customize*Value field for display without letting its watcher
    // write the (possibly defaulted) value into `model`, so opening a
    // "Customize Columns" modal never trips isDirty on its own — only an
    // actual edit (drag) or explicit Save should do that.
    hydrateCustomizeValue(valueKey, value) {
      this.suppressCustomizeModelSync = true
      this[valueKey] = value
      this.$nextTick(() => { this.suppressCustomizeModelSync = false })
    },
    updateHistoryFieldsFromCustomize() {
      this.model.vehicle_status_management_visible_history_fields = this.customizeHistoryColumnsValue
    },
    resetCustomizeHistoryColumns() {
      this.applyCustomizeReset(
        'customizeHistoryColumnsValue',
        'customizeHistoryColumnsResetKey',
        this.updateHistoryFieldsFromCustomize,
        defaultHistoryVisibleFieldsString(this.availableHistoryFieldsForCustomize),
        'History'
      )
    },
  } ,
  computed:{
    ...mapState({
      user: state => state.profile.user,
      viewAs: state => state.profile.view_as,
    }),
    availableFieldsForCustomize() {
      // Filter VSM fields based on user_customizable_fields setting
      const userCustomizableFields = this.model.vehicle_status_management_user_customizable_fields || ''
      
      // If empty, allow all fields
      if (!userCustomizableFields || userCustomizableFields.trim() === '') {
        return this.tenantVsmFields
      }
      
      // Otherwise, only show fields that are in the user_customizable_fields list
      const allowedKeys = userCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
      return this.tenantVsmFields.filter(field => allowedKeys.includes(field.key))
    },
    // the spanish board is read-only, so its picker leaves out the row-action columns
    availableEsFieldsForCustomize() {
      return this.availableFieldsForCustomize.filter(f => !VSM_ES_EXCLUDED_KEYS.includes(f.key))
    },
    availableHistoryFieldsForCustomize() {
      // Filter history fields based on history_customizable_fields setting
      const historyCustomizableFields = this.model.vehicle_status_management_history_customizable_fields || ''
      
      // If empty, allow all history fields
      if (!historyCustomizableFields || historyCustomizableFields.trim() === '') {
        return VSM_HISTORY_FIELDS
      }
      
      // Otherwise, only show fields that are in the history_customizable_fields list
      const allowedKeys = historyCustomizableFields.split(',').map(k => k.trim()).filter(k => k)
      return VSM_HISTORY_FIELDS.filter(field => allowedKeys.includes(field.key))
    },
    isEffectiveAdmin() {
      return this.user.role === 'admin' && this.viewAs !== 'non-admin'
    },
    telematics_type() {
      return this.user.telematics_types[this.user.tenant]
    },
    tenant_type() {
      return this.user.types[this.user.tenant]
    },
    tenantVsmFields() {
      return VSM_FIELDS.filter(f => !f.tenant_types || f.tenant_types.includes(this.tenant_type))
    },
    // which board this tenant's VSM link opens -- the columns an unconfigured
    // Customize Columns modal seeds with come from that board's own fallback,
    // and the boards do not share one
    vsmBoardRoute() {
      const features = (this.user.features || {})[this.user.tenant]
      return vsmBoardRouteName(this.tenant_type, features)
    }
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    },
    customizeColumnsValue: {
      handler(newVal) {
        // Update the visible_fields model whenever customizeColumnsValue changes,
        // unless this is the initial display hydration from a backend default.
        if (this.view_customize_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_fields = newVal
        }
      },
      immediate: false
    },
    customizeStandaloneColumnsValue: {
      handler(newVal) {
        if (this.view_customize_standalone_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_standalone_fields = newVal
        }
      },
      immediate: false
    },
    customizeCleaningColumnsValue: {
      handler(newVal) {
        if (this.view_customize_cleaning_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_cleaning_fields = newVal
        }
      },
      immediate: false
    },
    customizeActiveColumnsValue: {
      handler(newVal) {
        if (this.view_customize_active_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_active_fields = newVal
        }
      },
      immediate: false
    },
    customizeMaintenanceColumnsValue: {
      handler(newVal) {
        if (this.view_customize_maintenance_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_maintenance_fields = newVal
        }
      },
      immediate: false
    },
    customizeDriverColumnsValue: {
      handler(newVal) {
        if (this.view_customize_driver_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_driver_fields = newVal
        }
      },
      immediate: false
    },
    customizeEsColumnsValue: {
      handler(newVal) {
        if (this.view_customize_es_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_es_fields = newVal
        }
      },
      immediate: false
    },
    customizeMobileColumnsValue: {
      handler(newVal) {
        if (this.view_customize_mobile_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_mobile_fields = newVal
        }
      },
      immediate: false
    },
    customizeHistoryColumnsValue: {
      handler(newVal) {
        if (this.view_customize_history_columns && !this.suppressCustomizeModelSync) {
          this.model.vehicle_status_management_visible_history_fields = newVal
        }
      },
      immediate: false
    }
  }
}
</script>
<style>
@import "../../node_modules/@syncfusion/ej2-base/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-lists/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-popups/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-buttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-navigations/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-splitbuttons/styles/bootstrap5.css";
@import "../../node_modules/@syncfusion/ej2-richtexteditor/styles/bootstrap5.css";
</style>

